module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-11.1ce41116.png";